import { SparklesIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';

import NotFound from '@/components/pages/NotFound/NotFound';
import PermissionsWrapper from '@/components/templates/PermissionsWrapper';
import { PaidFeatureGate } from '@/modules/billing/components/PaidFeatureGate/PaidFeatureGate';
import { PaidFeatureUpsell } from '@/modules/billing/components/PaidFeatureUpsell/PaidFeatureUpsell';
import { PageName } from '@/shared/types/segment';

import { ImprovementsPage } from './ImprovementsPage';

export const ImprovementsRouter = () => {
  const { t } = useTranslation();

  return (
    <PaidFeatureGate
      pageName={PageName.IMPROVEMENTS}
      paywall={
        <PaidFeatureUpsell
          icon={<SparklesIcon aria-hidden />}
          title={t('improvements.paywall_title')}
          description={t('improvements.paywall_description')}
        />
      }
    >
      <PermissionsWrapper module="brains">
        <Routes>
          <Route index element={<ImprovementsPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PermissionsWrapper>
    </PaidFeatureGate>
  );
};
